import { Suspense, lazy } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { Skeleton } from '@/components/ui/skeleton';

// Dev-only: in production builds `import.meta.env.DEV` is false, so the style guide and its
// sample data are dead code and never shipped; the route itself answers "Page not found".
const StyleGuide = import.meta.env.DEV ? lazy(() => import('@/features/dev-ui/style-guide')) : null;

export const Route = createFileRoute('/dev/ui')({
  beforeLoad: () => {
    if (!StyleGuide) throw notFound();
  },
  component: DevUiPage,
});

function DevUiPage() {
  if (!StyleGuide) return null;
  return (
    <Suspense fallback={<Skeleton className="m-6 h-96" />}>
      <StyleGuide />
    </Suspense>
  );
}
